import { HTMLProps } from 'react';
import { Stack, IconButton, styled, IconButtonProps } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { useWhatsapp } from '../../hooks/useWhatsapp';

type CustomIconButtonProps = IconButtonProps & HTMLProps<HTMLInputElement>

// Extend IconButtonProps with our bgColor
interface SocialIconButtonProps extends CustomIconButtonProps {
  bgColor: string;
}

const SocialIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'bgColor',
})<SocialIconButtonProps>(({ bgColor }) => ({
  backgroundColor: bgColor,
  color: '#fff',
  '&:hover': {
    backgroundColor: bgColor,
    opacity: 0.85,
  },
  borderRadius: '50%',
}));

interface SocialButtonsProps {
  subject?: string;
  body?: string;
  size: any;
}

function SocialButtons({ size = 'medium', subject = "", body = "" }: SocialButtonsProps) {
  const openWhatsapp = useWhatsapp("");

  // Build mailto link
  const params = new URLSearchParams();
  if (subject) params.append("subject", subject);
  if (body) params.append("body", body);

  const mailtoLink = `mailto:${process.env.REACT_APP_PROFILE_EMAIL}${params.toString() ? "?" + params.toString() : ""}`;

  return (
    <Stack direction="row" spacing={2}>
      <SocialIconButton
        component="a"
        href={process.env.REACT_APP_FACEBOOK_HREF + "/" + process.env.REACT_APP_FACEBOOK_PROFILE}
        target="_blank"
        rel="noopener noreferrer"
        bgColor="#1877F2"
        size={size}
      >
        <FacebookIcon />
      </SocialIconButton>
      <SocialIconButton
        onClick={openWhatsapp}
        bgColor="#25D366"
        size={size}
      >
        <WhatsAppIcon />
      </SocialIconButton>

      <SocialIconButton 
        component="a" 
        href={"tel:" + process.env.REACT_APP_PROFILE_TEL} 
        bgColor="#4CAF50"
        size={size}
      >
        <PhoneIcon />
      </SocialIconButton>
  
      <SocialIconButton 
        component="a"
        href={mailtoLink} 
        bgColor="#D44638"
        size={size}
      >
        <EmailIcon />
      </SocialIconButton>
    </Stack>
  );
};

export default SocialButtons;
